const animate = ( {timing, draw, duration, cancelCallback = () => false} ) => {
	const start = performance.now();
	
	const animateFraction = ( time ) => {
		let timeFraction = ( time - start ) / duration;
		if ( timeFraction > 1 )
		{
			timeFraction = 1;
		}
		
		const progress = timing( timeFraction );
		
		draw( progress );
		
		if ( timeFraction < 1 )
		{
			const requestId = window.requestAnimationFrame( animateFraction );
			
			if ( cancelCallback() )
			{
				window.cancelAnimationFrame( requestId );
			}
		}
	};
	
	window.requestAnimationFrame( animateFraction );
};

export {
	animate,
};
